module.exports = __webpack_public_path__ + "img/Postmodernisme_Paal-Helge-Haugen.07897dc0.jpg";